import { render, staticRenderFns } from "./buttonBar.component.vue?vue&type=template&id=ecbf5d7e"
import script from "./buttonBar.component.ts?vue&type=script&lang=ts&external"
export * from "./buttonBar.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports